import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row pt-10" }
const _hoisted_3 = { class: "col-12 d-flex justify-content-between align-items-end" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", null, "Updated on 01 Sep 2022", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-sm btn-secondary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-share-fill" }),
  /*#__PURE__*/_createTextVNode(" Share ")
], -1)
const _hoisted_7 = { class: "row g-5 py-5" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"border border-secondary rounded-3 p-3 my-10\"><div class=\"d-flex justify-content-between align-items-center\"><span class=\"lead fw-bold\">Did you get the help you needed?</span><div class=\"d-inline-flex\"><button class=\"btn btn-sm btn-outline btn-outline-default me-2\"> Yes </button><button class=\"btn btn-sm btn-outline btn-outline-default\"> No </button></div></div></div>", 1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4\"><div class=\"d-flex flex-column bg-ispk-primary bg-gradient p-10 rounded-3\"><div class=\"text-left p-5\"><h2 class=\"text-white\"> Tidak dapat mencari apa yang anda perlukan? </h2><span class=\"text-white\">Try this next steps:</span></div><div class=\"d-inline-flex align-items-end p-5 bg-light rounded-3\"><div class=\"btn btn-sm btn-icon btn-secondary me-5\"><i class=\"bi bi-headset text-primary\"></i></div><div class=\"d-flex flex-column\"><span class=\"fw-bold\">Hubungi Kami</span><small>Team kami sedia membantu anda</small></div></div></div></div>", 1)
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = { class: "d-flex justify-content-between align-items-center py-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h2", null, "Related Article", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right text-active" }, null, -1)
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass([
              'card',
              'card-bordered',
              'bg-transparent',
              'border-2',
              'border-secondary',
              'h-100',
            ])
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body text-black" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, " I’ve forgot my username and password. What do I do? "),
    /*#__PURE__*/_createElementVNode("div", { class: "text-truncate" }, " You can click on “forgot username” or “forgot password” and proceed accordingly. Your ID and/or password will be sent to you via the email address you registered at the time .. ")
  ])
], -1)
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass([
              'card',
              'card-bordered',
              'bg-transparent',
              'border-2',
              'border-secondary',
              'h-100',
            ])
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body text-black" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Is the application free?"),
    /*#__PURE__*/_createElementVNode("div", { class: "text-truncate" }, " You can click on “forgot username” or “forgot password” and proceed accordingly. Your ID and/or password will be sent to you via the email address you registered at the time .. ")
  ])
], -1)
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: /*#__PURE__*/_normalizeClass([
              'card',
              'card-bordered',
              'bg-transparent',
              'border-2',
              'border-secondary',
              'h-100',
            ])
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body text-black" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "How do I create an account?"),
    /*#__PURE__*/_createElementVNode("div", { class: "text-truncate" }, " You can click on “forgot username” or “forgot password” and proceed accordingly. Your ID and/or password will be sent to you via the email address you registered at the time. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.article.title), 1),
          _hoisted_5
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, _toDisplayString(_ctx.article.content), 1),
        _hoisted_9
      ]),
      _hoisted_10
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_router_link, {
          class: "btn btn-link",
          to: { name: 'help-page' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" View More "),
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, { to: { path: 'article' } }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_router_link, { to: { path: 'article' } }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_router_link, { to: { path: 'article' } }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ])
    ])
  ]))
}